import React from 'react';
import { FilterOption } from '../../../components/ui';
import {
  OnlyFansIc,
  InstagramIc,
  GoogleIc,
  TwitterIc,
  GlobalIc,
  IcReddit,
  IcAnotherSoc,
  IcTg,
  IcTikTok,
  IcYoutube,
} from '../../../components/icons';
import { useTranslations } from '../../../contexts/translation.context';

export const getSortOptions = (t: any): FilterOption[] => [
  { key: 'all', label: t('proposals.sorting') },
  { key: 'subs.price', label: t('proposals.priceColumn') },
  { key: '-subs.price', label: t('proposals.priceColumn') },
  { key: 'subs_max', label: t('proposals.trafficVolume') },
  { key: '-subs_max', label: t('proposals.trafficVolume') },
  { key: 'created_at', label: t('proposals.added') },
  { key: '-created_at', label: t('proposals.added') },
  { key: 'updated_at', label: t('proposals.updated') },
  { key: '-updated_at', label: t('proposals.updated') },
];

export const getProposalSources = (t: any): FilterOption[] => [
  {
    key: 'all',
    label: t('proposals.allSources'),
    icon: React.createElement(GlobalIc, { size: 16 }),
  },
  {
    key: 'only_fans',
    label: t('proposals.onlyFans'),
    icon: React.createElement(OnlyFansIc, { size: 16, fill: '#A8A8B0' }),
  },
  {
    key: 'reddit',
    label: t('proposals.reddit'),
    icon: React.createElement(IcReddit, { size: 16 }),
  },
  {
    key: 'instagram',
    label: t('proposals.instagram'),
    icon: React.createElement(InstagramIc, { size: 16, fill: '#A8A8B0' }),
  },
  {
    key: 'tiktok',
    label: t('proposals.tiktok'),
    icon: React.createElement(IcTikTok, { size: 16 }),
  },
  {
    key: 'google',
    label: t('proposals.google'),
    icon: React.createElement(GoogleIc, { size: 16, fill: '#A8A8B0' }),
  },
  {
    key: 'telegram',
    label: t('proposals.telegram'),
    icon: React.createElement(IcTg, { size: 16 }),
  },
  {
    key: 'twitter',
    label: t('proposals.twitter'),
    icon: React.createElement(TwitterIc, { size: 16, fill: '#A8A8B0' }),
  },
  {
    key: 'youtube',
    label: t('proposals.youtube'),
    icon: React.createElement(IcYoutube, { size: 16 }),
  },
  {
    key: 'another',
    label: t('proposals.other'),
    icon: React.createElement(IcAnotherSoc, { size: 16 }),
  },
];

export const getTableColumns = (t: any) => [
  { name: t('proposals.marketer'), key: 'partner', width: '22%' },
  { name: t('proposals.description'), key: 'description', width: '38%' },
  { name: t('proposals.priceColumn'), key: 'price', width: '14%' },
  { name: '', key: 'actions', width: '26%' },
];

export const getStatusLabels = (t: any) =>
  ({
    active: t('proposals.active'),
    inactive: t('proposals.inactive'),
    pending: t('proposals.pending'),
    suspended: t('proposals.suspended'),
  }) as const;

export const DEFAULT_FILTERS = {
  search: '',
  sort: 'all',
  source: 'all',
  featured: false,
  suitable: false,
  offer_type: 'all',
  campaign_type: 'all',
  partner_level: 'all',
  price_min: null,
  price_max: null,
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;
